import { SuscriptionForm } from './SuscriptionForm';

export type { TypeSuscriptionFormProps } from './types';
export default SuscriptionForm;
